
<template>
    <div class="login-wrap">
        <div class="logo-wrap">
            <img src="~@/image/icn-logo-b.svg">
        </div>
        <div class="login-content-wrap full">
            <div>
                <div class="form-control-content-wrap" style="display:none">
                    <p class="title">대표소속</p>
                    <div class="form-control-content">
                        <select class="form-control-select" v-model="group">
                            <option :value="null"></option>
                            <option v-for="(team) in teams.teamList" :value="team.userId">{{team.orgParentName}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-control-content-wrap">
                    <p class="title">성별</p>
                    <div class="form-control-content">
                        <select class="form-control-select" v-model="gender">
                            <option :value="null">성별</option>
                            <option value="M">남성</option>
                            <option value="W">여성</option>
                        </select>
                    </div>
                </div>
                <div class="form-control-content-wrap">
                    <p class="title">생년월일</p>
                    <div class="form-control-content three">
                        <input type="number" placeholder="연도(4자리)" v-model="year">
                        <select v-model="month" class=" form-control-select margin-item">
                            <option :value="null">월선택</option>
                            <option :value="i" v-for="(i) in 12">{{i}}월</option>
                        </select>
                        <select v-model="day" class=" form-control-select">
                            <option :value="null">일선택</option>
                            <option :value="i" v-for="(i) in 31">{{i}}일</option>
                        </select>
                    </div>
                </div>

                <div class="btn-wrap">

                    <div class="document-btn" @click="joinFunc()">가입완료하기</div>

                </div>
            </div>
        </div>

        <alert-modal :title="alertTitle" :content="alertContent" v-if="alertShow" @close="alertShow=false"></alert-modal>

    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import AlertModal from "../modal/AlertModal";
    export default{
        computed: {
            ...mapState('users', ['teams'])
        },
        components: {AlertModal},
        data(){
            return{
                group: null,
                gender: null,
                year: null,
                month: null,
                day: null,

                alertTitle: '알림',
                alertContent: '알림',
                alertShow: false,


            }
        },
        methods: {
            joinFunc(){
                const _this = this
                if(this.validationFunc()){

                    const temp = {
                        mobile: this.$route.query.mobile.replace(/-/g, ''),
                        userName: this.$route.query.name,
                        certKey: this.$route.query.certKey,
                        dateOfBirth: this.returnBirth(),
                        gender: this.gender,
                        representId: 1
                    }


                    this.$store.dispatch('users/requestSignUp', temp).then(res => {
                        if(res.accessToken){
                            _this.$router.replace('/')
                        }else{
                            _this.$router.replace('/')
                        }

                    }).catch(err => {
                        _this.$router.replace('/')
                        // console.dir('users/requestSignUp')
                        // console.dir(err)
                        //_this.alertFunc('오류가 발생했습니다. 잠시 후 시도해주세요')
                    })
                }
            },
            returnBirth(){

                let month = `${this.month <10 ? '0'+this.month : this.month}`
                let day = `${this.day <10 ? '0'+this.day : this.day}`
                const birth = `${this.year}${month}${day}`

                return birth
            },
            validationFunc(){
                let validate = true

                if(this.teams.teamList.length > 0 && !this.group){
                    validate = false
                    this.alertFunc('대표 소속을 선택해주세요')
                }else if(!this.gender){
                    validate = false
                    this.alertFunc('성별을 선택해주세요')
                }else if(!this.year && !this.month && !this.day){
                    validate = false
                    this.alertFunc('생년월일을 입력해주세요')
                }else if(this.isBelow14(this.year, this.month, this.day)){
                    this.alertFunc('만 14세 미만은 회원가입할 수 없습니다. 회원가입 없이도 대부분의 정보를 확인할 수 있습니다.');
                    return false;
                }else{
                    const birth = this.returnBirth()
                    const regExp = /^\d{4}\d{2}\d{2}$/;
                    if(!regExp.test(birth)){
                        validate = false
                        this.alertFunc('입력하신 생년월일 형식이 올바르지 않습니다.')
                    }
                }

                return validate;
            },
            alertFunc(content){
                this.alertContent = content
                this.alertShow = true
            },
            isBelow14(year, month, day) {
                const today = new Date();
                const birthday = new Date(year, month-1, day);
                const diffYear = today.getFullYear() - birthday.getFullYear();
                const diffMonth = today.getMonth() - birthday.getMonth();
                const diffDay = today.getDate() - birthday.getDate();

                // 년도 차이가 14이면 월과 일 차이도 체크
                if (diffYear === 14) {
                    // 월 차이가 마이너스면 아직 생일이 지나지 않은 상태
                    if (diffMonth < 0) {
                    return true; // 만 14세 미만
                    } else if (diffMonth === 0) {
                    if (diffDay < 0) {
                        return true; // 만 14세 미만
                    } else {
                        return false; // 만 14세 이상
                    }
                    } else {
                    return false; // 만 14세 이상
                    }
                } else if (diffYear < 14) {
                    return true; // 아직 14세 미만
                } else {
                    return false; // 14세 이상
                }
            }
        }
    }
</script>
